import RootStore from './RootStore';
import * as api from '../services';

const root = RootStore.create({}, { api });
export default root;
